import { forwardRef } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { useUIDSeed } from 'react-uid'

import Button from 'components/Button'
import ArrowRightIcon from 'public/icons/arrow-right.svg'
import { ServicesBlockItem } from 'components/ServicesBlock'

import style from './ServicesBlock.style'

const ServicesBlockStyled = styled.div(props => ({ ...style(props) }))

const ServicesBlock = forwardRef(
    (
        { title, titleTag: TitleTag, subtitle, text, buttonText, buttonLink, buttonIcon, data, noBg, offsetFunc },
        ref
    ) => {
        const uid = useUIDSeed()
        return (
            <ServicesBlockStyled noBg={noBg} noHeading={!title && !subtitle} ref={ref}>
                <div className="ServicesContainer">
                    {(title || subtitle) && (
                        <div className="Heading">
                            {title && <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title }} />}
                            {subtitle && <p className="Subtitle">{subtitle}</p>}
                        </div>
                    )}
                    <div className="Content">
                        {text && <p className="Text">{text}</p>}
                        <ul className="ServicesList">
                            {data.map(item => (
                                <li key={uid(item)}>
                                    <ServicesBlockItem text={item.text} icon={item.icon} />
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="CtaContainer">
                        {buttonLink && (
                            <Button
                                small
                                white
                                variation="primary rounded"
                                link={buttonLink}
                                dataAttrs={{
                                    'gtm-event': 'link',
                                    'gtm-label': title,
                                    'gtm-action': buttonText,
                                    'gtm-category': 'ServiceBlock'
                                }}>
                                {buttonText}
                                {buttonIcon && <ArrowRightIcon />}
                            </Button>
                        )}
                    </div>
                </div>
            </ServicesBlockStyled>
        )
    }
)

ServicesBlock.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    titleTag: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonIcon: PropTypes.bool,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
            text: PropTypes.string
        })
    ),
    noBg: PropTypes.bool,
    offsetFunc: PropTypes.string
}

ServicesBlock.defaultProps = {
    title: undefined,
    titleTag: 'p',
    text: null,
    subtitle: null,
    buttonText: null,
    buttonLink: null,
    buttonIcon: null,
    data: [],
    noBg: false,
    offsetFunc: undefined
}

export default withTheme(ServicesBlock)
